import { FC } from 'react';
import { Perform } from './perform';

interface PerformTextProps {
    name: string;
    value: string;
}

export const PerformText: FC<PerformTextProps> = ({ value, name }: PerformTextProps) => (
    <Perform name={name} text={value} />
);
